import { render, staticRenderFns } from "./FormHeadline.vue?vue&type=template&id=61fd5f79&"
import script from "./FormHeadline.vue?vue&type=script&lang=js&"
export * from "./FormHeadline.vue?vue&type=script&lang=js&"
import style0 from "./FormHeadline.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormHeadline.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports